// root '../../../';

// dependencies
import { Child } from 'pym.js';
import { select } from 'd3-selection';

// polyfills
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
import config from './config';
import graphic from './graphic';

// styles
import './styles/index.scss';

/* develblock:start */
import meta from './data/meta.json';

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

const DATA_URL = 'https://ix.cnn.io/data/acled-israel-hezbollah/israel_hezbollah_strikes.json';

let cachedData = [];

function draw(initialWidth) {
  const container = select('#graphic');
  container.html('');

  const fallbackWidth = container.node().clientWidth || 600;
  const safeWidth = initialWidth !== fallbackWidth ? fallbackWidth : initialWidth;
  const isMobile = safeWidth <= 500;

  const props = { initialWidth: safeWidth, isMobile };

  const graphicConfig = config(props, cachedData);
  graphic(graphicConfig, container, isMobile);

  const { pymChild } = window;
  if (pymChild) pymChild.sendHeight();
}

async function init() {
  try {
    const res = await fetch(DATA_URL);
    const json = await res.json();
    cachedData = json;
    console.log(json);
    select('#footer .footnote').text(
      'Note: Data includes attacks involving Hezbollah and the Military Forces of Israel'
      + ' and covers air and drone strikes, shelling, artillery and missile attacks. Does not include events outside of Israel or Lebanon, such as strikes in Israel-occupied Golan Heights.'
      + ` Data through ${json.dataEnd}, last fetched ${json.lastUpdatedStr}.`,
    );
  } catch (e) {
    console.error('Failed to fetch strike data:', e);
  }

  window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);
      if (node) node.innerHTML = meta[id];
    });
  }
}

init();
